import { Injectable } from "@angular/core";
import { RxApiService } from "../../../core/communication/http/rx-api.service";
import { Observable } from "rxjs";
import {
    FeedbackMessage,
    FeedbackMessagesResponse,
    FeedbackThread,
    ListResponseData
} from "../../../core/types";

export interface ListMessagesParams {
    since?: string;
    till?: string;
    limit?: number;
    issues?: boolean;
    status_till?: string;
    force_issues?: boolean;
}

export interface CreateMessageDataMessage {
    created_on: string;
    text: string;
}

export interface CreateMessageData {
    message: CreateMessageDataMessage;
}

@Injectable()
export class ApplicationFeedbackService {
    constructor(private api: RxApiService) {}

    public createThread(appId: string, data: any): Observable<FeedbackThread> {
        return this.api.post(["apps", appId, "feedback", "threads"], {}, data);
    }

    public listThreads(appId: string, params?: any): Observable<ListResponseData<FeedbackThread>> {
        return this.api.get(["apps", appId, "feedback", "threads"], params);
    }

    public updateThread(appId: string, threadId: string, threadData: any): Observable<any> {
        return this.api.patch(["apps", appId, "feedback", "threads", threadId], {}, threadData);
    }

    public listMessages(
        appId: string,
        threadId: string,
        params?: ListMessagesParams
    ): Observable<FeedbackMessagesResponse> {
        return this.api.get(["apps", appId, "feedback", "threads", threadId, "messages"], params);
    }

    public createMessage(
        appId: string,
        threadId: string,
        messageData: CreateMessageData
    ): Observable<FeedbackMessage | FeedbackMessage[]> {
        return this.api.post(
            ["apps", appId, "feedback", "threads", threadId, "messages"],
            {},
            messageData
        );
    }

    public updateStatuses(appId: string, threadId: string, updateData: any): Observable<any> {
        return this.api.post(
            ["apps", appId, "feedback", "threads", threadId, "messages", "statuses"],
            {},
            updateData
        );
    }
}
